import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Header.css";
import logoImg from "../assets/amresh-prajapati-website-developer-logo.webp";

const navLinks = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About Us" },
  { path: "/services", label: "Services" },
  { path: "/projects", label: "Projects" },
  { path: "/faq", label: "FAQ's" },
  { path: "/contact", label: "Contact Us" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    handleScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <>
      <header className={`header${scrolled ? " header--scrolled" : ""}`}>
        <div className="header__container">
          <Link
            to="/"
            className="header__logo"
            aria-label="Amresh Prajapati Home"
            title="Amresh Prajapati"
          >
            <img
              src={logoImg}
              alt="Amresh Prajapati - Freelance Website Developer in Mumbai"
              width="160"
              height="60"
            />
          </Link>

          <nav className="header__nav" aria-label="Primary navigation">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                end={link.path === "/"}
                className={({ isActive }) =>
                  `header__link${isActive ? " header__link--active" : ""}`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="header__right">
            <Link
              to="/contact"
              className="header__cta"
              title="Hire Amresh Prajapati"
            >
              Hire Me
            </Link>

            <button
              type="button"
              className="header__burger"
              onClick={() => setMenuOpen(true)}
              aria-label="Open navigation menu"
              aria-expanded={menuOpen}
              aria-controls="mobile-navigation"
            >
              <FaBars />
            </button>
          </div>
        </div>
      </header>

      <div
        className={`header__overlay${menuOpen ? " header__overlay--visible" : ""}`}
        onClick={() => setMenuOpen(false)}
        aria-hidden="true"
      />

      <aside
        id="mobile-navigation"
        className={`header__mobile${menuOpen ? " header__mobile--open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile navigation menu"
      >
        <div className="header__mobile-header">
          <span className="header__mobile-brand">Amresh Prajapati</span>

          <button
            type="button"
            className="header__close"
            onClick={() => setMenuOpen(false)}
            aria-label="Close navigation menu"
          >
            <FaTimes />
          </button>
        </div>

        <div className="header__mobile-divider" />

        <nav className="header__mobile-nav" aria-label="Mobile navigation">
          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              end={link.path === "/"}
              className={({ isActive }) =>
                `header__mobile-link${
                  isActive ? " header__mobile-link--active" : ""
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="header__mobile-footer">
          <Link to="/contact" className="header__mobile-cta">
            Hire Amresh Prajapati
          </Link>
        </div>
      </aside>
    </>
  );
};

export default Header;